import { useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import { Icon, Loader, Progress } from "semantic-ui-react";
import styled from "styled-components";

// @ts-ignore
import AppIcon from "src/images/appIcon.png";
import { useAppSelector } from "store";
import util from "utils/utils";

const SuspenseContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  img {
    height: 75px;
    min-width: 75px;
  }
  span {
    display: block;
    font-weight: 600;
    opacity: 0.8;
    font-size: 1.3em;
    margin: 12px 0 24px 0;
  }
`;

const NumberOfSeconds = 5;
const NumberOfMilliseconds = NumberOfSeconds * 1000;

const SuspenseLoading = () => {
  const user = useAppSelector((state) => state.user);
  const [msCounted, setMsCounted] = useState(0);
  const [index, setIndex] = useState(0);

  const { t } = useTranslation();

  const loadingMessages = useMemo(
    () => [
      `Polishing ${t("generic.challenges")}`,
      "Sourcing innovation",
      `Loading ${t("generic.ideas")}`,
      `Evaluating ${t("generic.impacts")}`,
      `Analysing solutions`,
      `Testing prototypes`,
      `Validating ${t("generic.ideas")}`,
      `Preparing groups`,
      `Configuring updates`,
    ],
    [t],
  );

  const percentageDone = useMemo(
    () => (msCounted / NumberOfMilliseconds) * 100,
    [msCounted],
  );

  const loadingMessage = useMemo(
    () => loadingMessages[index],
    [loadingMessages, index],
  );

  useEffect(() => {
    let start = 0;
    const countUp = setInterval(() => {
      setMsCounted((prevCount) =>
        prevCount >= NumberOfMilliseconds ? prevCount : prevCount + 100,
      );
      start += 100;
      if (start >= 1500) {
        start = 0;
        setIndex(Math.floor(Math.random() * loadingMessages.length));
      }
    }, 100);
    return () => clearInterval(countUp);
  }, [loadingMessages.length]);

  return (
    <SuspenseContainer>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img src={AppIcon} alt="SimplyDo app icon" />
        {user?.ownerOrganisation?.darkLogoUrl ?
          <>
            <Icon name="close" size="large" />
            <img
              src={user?.ownerOrganisation?.darkLogoUrl}
              alt="Owner organisation logo"
            />
          </>
        : null}
      </div>
      <span>
        {msCounted >= NumberOfMilliseconds || msCounted <= 300 ?
          `Setting up ${util.appName()}`
        : loadingMessage}
        ..
      </span>
      {msCounted >= NumberOfMilliseconds || msCounted <= 300 ?
        <Loader active inline="centered" />
      : <Progress
          percent={percentageDone}
          style={{ width: 300 }}
          size="small"
        />
      }
    </SuspenseContainer>
  );
};

export default SuspenseLoading;
